import { ReactElement, use } from 'react';
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';
import ModeEditOutlineOutlined from '@mui/icons-material/ModeEditOutlineOutlined';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';

import CareConnectSettingsProviderContext from 'features/care-connect-settings/contexts/care-connect-settings-provider-context';
import PersonalNumberRangeRowContext from 'features/care-connect-settings/contexts/personal-number-range-row-context';
import styles from './personal-number-range-row-viewing.module.scss';

const PersonalNumberRangeRowViewing = (): ReactElement => {
  const { personalNumberRange, startEditing } = use(PersonalNumberRangeRowContext);
  const { personalNumberRangeDetails } = use(CareConnectSettingsProviderContext);
  const { removePersonalNumberRange, isEditing } = personalNumberRangeDetails;

  return (
    <div className={styles.container}>
      <Typography variant="body1">{personalNumberRange.lowerBound}</Typography>
      <Typography variant="body1">{personalNumberRange.upperBound}</Typography>
      <div className={styles.buttonsContainer}>
        <IconButton className={styles.deleteButton} disabled={isEditing} onClick={() => removePersonalNumberRange(personalNumberRange)}>
          <DeleteForeverOutlinedIcon />
        </IconButton>
        <IconButton className={styles.editButton} disabled={isEditing} onClick={startEditing}>
          <ModeEditOutlineOutlined className={isEditing ? styles.disabledIcon : ''} />
        </IconButton>
      </div>
    </div>
  );
};

export default PersonalNumberRangeRowViewing;
